import classNames from 'classnames';
import { useContext, type FC } from 'react';
import { CheckBoxIcon } from 'src/components/shared/elements/icons/CheckBoxIcon';
import { type ShopSchema } from 'src/models/shop/schema';
import { I18nContext } from 'src/stores/I18n';
import { colors } from 'styles/colors';
import { type ShopModalMode } from './type';

type Props = {
  mode: ShopModalMode;
  setMode: (mode: ShopModalMode) => void;
  selectedShop?: ShopSchema;
  closeModal?: () => void;
  vjwChecked: boolean;
  onShopChange: (id: number) => void;
  checked: boolean;
  setChecked: (checked: boolean) => void;
};

export const ShopNavigation: FC<Props> = ({
  mode,
  setMode,
  selectedShop,
  closeModal,
  vjwChecked,
  onShopChange,
  checked,
  setChecked
}) => {
  const localeResources = useContext(I18nContext);
  const disabled = !selectedShop || (mode === 'vjw' && !vjwChecked);

  return (
    <div
      className={classNames(
        'max-w-[440px] flex flex-col gap-5 fixed bottom-0 left-0 right-0 z-[1001] p-5 bg-white',
        'transition-opacity duration-500',
        {
          'opacity-0 pointer-events-none': mode === 'list'
        }
      )}
    >
      {mode === 'vjw' ? (
        <label htmlFor="vjw-check" className="flex justify-center items-center gap-2 text-xs">
          <input
            type="checkbox"
            id="vjw-check"
            className="hidden"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <CheckBoxIcon
            bgColor={!checked ? colors.white : undefined}
            className={classNames({ 'border border-solid border-black rounded-[3px]': !checked })}
          />
          {localeResources.orders.vjwRegistered}
        </label>
      ) : null}
      <div className="flex justify-around">
        <button className="border border-solid border-black rounded-full px-5 py-2.5" onClick={() => setMode('list')}>
          {localeResources.receive.navigation.backToPickupList}
        </button>
        <button
          className={classNames('text-white rounded-full px-5 py-2.5', {
            'bg-primary': !disabled,
            'bg-gray-400': disabled
          })}
          disabled={disabled}
          onClick={() => {
            if (selectedShop?.pickupType === 'counter' && mode === 'detail') {
              setMode('vjw');
            } else {
              if (selectedShop) {
                onShopChange(selectedShop.id);
              }
              closeModal?.();
            }
          }}
        >
          {mode === 'detail' ? localeResources.receive.navigation.select : localeResources.receive.navigation.next}
        </button>
      </div>
    </div>
  );
};
